import styled from 'styled-components'

export const RowLabel = styled.div`
  width: 80%;
  float: left;
  font-size: 14px;
`
export const RowAmount = styled.div`
  font-weight: bold;
  font-size: 14px;
`
export const PaymentTotalRow = styled.div`
  width: 100%;
  font-weight: bold;
  padding: 8px;
`
export const DiscountItemRow = styled.div`
  font-weight: bold;
  width: 100%;
  border-bottom: 1px solid #dddddd;
  padding: 8px;
`
export const PaymentItemRow = styled.div`
  width: 100%;
  border-bottom: 1px solid #dddddd;
  padding: 8px;
`
export const EditSubscriptionLink = styled.a`
  text-decoration: none;
`
export const CurrentSubscriptionRow = styled.div`
  width: 100%;
  border-bottom: 1px solid #dddddd;
  padding: 8px;
`
export const SummaryTextRow = styled.div`
  font-weight: bold;
  width: 100%;
  padding: 0 8px 8px 8px;
  border-bottom: 1px solid #dddddd;
`
export const PaymentSummaryContainer = styled.div`
  text-align: left;
`
